import type { RouteRecordRaw, Router } from 'vue-router'
import { MODULE_ACCESS } from '@/modules/Core/constants/adminAccess'

const CategoryRoutes: RouteRecordRaw = {
  path: '/category',
  name: 'CategoryModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '',
      name: 'ManageCategoryRoute',
      component: () => import('./views/ManageCategoryView.vue'),
      meta: {
        title: 'دسته بندی ها',
      },
    },
    {
      path: ':parentId/sub-category',
      name: 'ManageSubCategoryRoute',
      component: () => import('./views/ManageSubCategoryView.vue'),
      meta: {
        title: 'زیردسته‌ها',
      },
    },
  ],
  meta: {
    layout: 'Default',
    allowedRoles: MODULE_ACCESS.category,
  },
}

export default (router: Router) => {
  router.addRoute(CategoryRoutes)
}
